import { useOptimizelyFeatureFlag } from '@shared/v2/contexts/optimizely';

import { PRICING_STRATEGIES } from '@/constants';

const FALLBACK_STRATEGY = PRICING_STRATEGIES.PER_PERSON;

export const usePricingStrategy = () => {
  const [decision] = useOptimizelyFeatureFlag(
    'jetstar-holidays-pricing-strategy',
  );
  return decision?.variables?.strategy ?? FALLBACK_STRATEGY;
};
